var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_3355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.67038 10.7532L6.38917 14.7085C6.7915 14.7085 6.96575 14.5357 7.17471 14.3282L9.061 12.5255L12.9696 15.3878C13.6864 15.7873 14.1915 15.577 14.3848 14.7284L16.9504 2.70654L16.9511 2.70584C17.1785 1.64617 16.5679 1.23179 15.8695 1.49175L0.789087 7.26538C-0.240121 7.66488 -0.224538 8.23863 0.614129 8.49859L4.46959 9.69779L13.425 4.09417C13.8465 3.81509 14.2297 3.9695 13.9145 4.24859L6.67038 10.7532Z",
    fill: "#272727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_3355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.fb3c3fec088824079e5affa23a83b640.svg";
export { ForwardRef as ReactComponent };